import { useMemo } from 'react'
import type { User } from '../types/word-discovery'

interface SupabaseProfile {
  id: string
  name: string
  avatar_url?: string | null
}

interface WordWithUsers {
  submitter?: SupabaseProfile
  alternatives?: Array<{
    proposer?: SupabaseProfile
  }>
}

/**
 * Extracts unique users from foreign words data
 * Combines submitters and alternative proposers into a deduplicated User array
 */
export function useExtractUsers(foreignWords: WordWithUsers[]): User[] {
  return useMemo(() => {
    return Array.from(
      new Map(
        foreignWords.flatMap(word => {
          const wordUsers: Array<[string, User]> = []

          if (word.submitter) {
            wordUsers.push([word.submitter.id, {
              id: word.submitter.id,
              name: word.submitter.name,
              avatarUrl: word.submitter.avatar_url || null,
            }])
          }

          word.alternatives?.forEach(alt => {
            if (alt.proposer) {
              wordUsers.push([alt.proposer.id, {
                id: alt.proposer.id,
                name: alt.proposer.name,
                avatarUrl: alt.proposer.avatar_url || null,
              }])
            }
          })

          return wordUsers
        })
      ).values()
    )
  }, [foreignWords])
}

